var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExitEmployeeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.495,
    viewBox: "0 0 18 18.495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(-362 -3332.756)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2412",
    "data-name": "Rectangle 2412",
    width: 18,
    height: 18,
    transform: "translate(362 3333)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "surface1",
    transform: "translate(358.68 3329.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M8.9,4.139A3.712,3.712,0,0,0,6.316,7.785C6.31,11.9,12.1,13.218,14.082,9.544a3.883,3.883,0,0,0-.807-4.556A3.836,3.836,0,0,0,10.565,3.9,3.117,3.117,0,0,0,8.9,4.139ZM12.3,5.11a3.172,3.172,0,0,1-.123,5.453,2.363,2.363,0,0,1-1.731.383A2.872,2.872,0,0,1,7.993,10.1a2.76,2.76,0,0,1-.951-2.319A2.842,2.842,0,0,1,8.43,5.131,2.933,2.933,0,0,1,10.6,4.6,2.288,2.288,0,0,1,12.3,5.11Zm0,0",
    transform: "translate(1.5 0)",
    fill: "#292d32",
    stroke: "#292d32",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M8.261,9.028a7.074,7.074,0,0,0-2.709,1.6c-.978,1.033-1.231,1.8-1.231,3.8,0,1.32.048,1.4,1.095,1.922,1.259.6,1.663.068.431-.568l-.732-.369-.041-1.279c-.034-1.533.137-2.155.828-2.915A5.731,5.731,0,0,1,8.309,9.74l.746-.26.718.274a7.9,7.9,0,0,0,4.221,0c.8-.308.965-.28,2.107.233.807.363,1.026.363,1.026-.014,0-.253-.746-.664-1.792-.992-.623-.2-.65-.192-1.539.1a6.012,6.012,0,0,1-3.619.062A2.183,2.183,0,0,0,8.261,9.028Zm0,0",
    transform: "translate(0 3.724)",
    fill: "#292d32",
    stroke: "#292d32",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M11.878,10.288a3.63,3.63,0,0,0-2.353,2.306,4.166,4.166,0,0,0,.28,2.785,3.8,3.8,0,0,0,6.65-.26,3.51,3.51,0,0,0-1.717-4.646A4.013,4.013,0,0,0,11.878,10.288Zm2.408.739a2.957,2.957,0,0,1,1.5,1.334,3.125,3.125,0,0,1,0,2.573,3.329,3.329,0,0,1-1.526,1.4,4.07,4.07,0,0,1-2.34.02,3.522,3.522,0,0,1-1.56-1.4,3.293,3.293,0,0,1-.062-2.484A3.123,3.123,0,0,1,14.286,11.027Zm0,0",
    transform: "translate(3.82 4.674)",
    fill: "#292d32",
    stroke: "#292d32",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M10.745,11.3c-.294.1-.157.459.39.972l.547.513-.547.54c-.575.547-.684.889-.356,1.019.123.048.39-.13.794-.506l.6-.561.6.561c.4.376.671.554.794.506.342-.13.205-.479-.356-1.019l-.547-.513.561-.554c.533-.527.657-.9.328-1.006-.089-.034-.424.2-.766.506l-.623.547-.575-.54a3.77,3.77,0,0,0-.636-.534A.71.71,0,0,0,10.745,11.3Zm0,0",
    transform: "translate(4.714 5.52)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M5.986,11.693a10.666,10.666,0,0,0,.027,1.662c.062,1.238.116,1.533.287,1.649a13.887,13.887,0,0,0,4.283.506c1.286-.034,1.348-.048,1.382-.308.021-.137,0-.253-.062-.253a24.129,24.129,0,0,1-4.94-.424c-.185-.048-.219-.212-.233-.842-.014-.431-.048-1.081-.089-1.43-.068-.54-.116-.643-.342-.677A.284.284,0,0,0,5.986,11.693Zm0,0",
    transform: "translate(1.236 5.773)",
    fill: "#292d32",
    stroke: "#292d32",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitEmployeeIcon);
export default __webpack_public_path__ + "static/media/exitEmployeeIcon.dfd56352d01da1f5b67f12b9304e4d2d.svg";
export { ForwardRef as ReactComponent };